import { inject, Injectable, signal, computed } from '@angular/core';
import { CurrencyService, LocalStorageManagerService } from '@zayan-erp/shared';
import { DsmSalesOfficeOption } from '../models/dsm-aps.models';

@Injectable({ providedIn: 'root' })
export class DsmStateService {
  #localStorageService = inject(LocalStorageManagerService);
  #currencyService = inject(CurrencyService);

  selectedSalesOfficeId = signal<string | null>(null);
  selectedSalesOffice = signal<DsmSalesOfficeOption | null>(null);
  selectedProjectId = signal<string | null>(null);

  readonly selectedCurrencyCode = computed(() => this.selectedSalesOffice()?.currencyCode?.toUpperCase() ?? 'CAD');

  setSalesOffice(id: string | null, salesOffice: DsmSalesOfficeOption | null = null): void {
    this.selectedSalesOfficeId.set(id);
    this.selectedProjectId.set(null);
    this.selectedSalesOffice.set(salesOffice);

    if (id) {
      this.#currencyService.updateCurrencyFromSalesOffice(id);
    }

    if (id) {
      this.#localStorageService.setDsmSalesOfficeIdToStorage(id);
    }
  }

  initFromStorage(availableSalesOffices: DsmSalesOfficeOption[]): void {
    if (!availableSalesOffices.length) return;

    const savedId = this.#localStorageService.getDsmSalesOfficeIdFromStorage();
    const selectedOffice = availableSalesOffices.find(office => office.id === savedId) ?? availableSalesOffices[0];

    this.setSalesOffice(selectedOffice?.id ?? null, selectedOffice ?? null);
  }
}
